import React, { useEffect, useRef, useState } from "react";
import { CrudModal } from "../../components/_index";
import { Formik, Form, Field } from "formik";
import Grid from "@mui/material/Grid2";
import { Typography, Button, Box } from "@mui/material";
import { postQuestion, updateQuestion } from "../../services/question.service";
import {
  postClient,
  updateClient,
} from "../../services/clientManagement.service";
import * as yup from "yup";
import { showToast } from "../../redux/Reducer/toastReducer";
import { useDispatch } from "react-redux";

const AddClientManagement = ({
  handleCloseDrawer,
  formType,
  selectedData,
  setOpenDrawer,
  GetClientData,
}) => {
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const [initialValues, setInitialValues] = useState({
    name: "",
    contactPersonName: "",
    contactPersonMobile: "",
    description: "",
  });

  const validationSchema = yup.object().shape({
    name: yup.string().required("Name Required *"),
    contactPersonName: yup.string().required("Contact Person Name Required *"),
    contactPersonMobile: yup
      .string()
      .required("Contact Person Mobile Required *"),
  });

  useEffect(() => {
    if (formType === "edit" || formType === "view") {
      setInitialValues({
        name: selectedData?.name || "",
        contactPersonName: selectedData?.contactPersonName || "",
        contactPersonMobile: selectedData?.contactPersonMobile || "",
        description: selectedData?.description || "",
      });
    }
  }, [formType, selectedData]);

  const onSubmit = async (values) => {
    try {
      const apiMethod =
        formType === "edit"
          ? updateClient(selectedData._id, values)
          : postClient(values);
      const res = await apiMethod;
      setOpenDrawer(false);
      GetClientData();
      dispatch(showToast({ message: res.message, type: "success" }));
    } catch (error) {
      dispatch(showToast({ message: error.data.message, type: "success" }));
    }
  };
  return (
    <CrudModal
      title={
        formType === "add"
          ? "Add Client"
          : formType === "edit"
          ? "Edit Client"
          : "View Client"
      }
      open={true}
      handleClose={handleCloseDrawer}
      maxWidth="md"
    >
      <Formik
        innerRef={formRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ touched, errors, values }) => (
          <div className="formContainer" style={{ height: "fit-content" }}>
            <Form>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    Name
                  </Typography>
                  <Field
                    name="name"
                    className="InputField"
                    placeholder="Enter Client Name"
                  />
                  <div className="form-error">
                    {touched.name && errors.name && errors.name}
                  </div>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    Contact Person Name
                  </Typography>
                  <Field
                    name="contactPersonName"
                    className="InputField"
                    placeholder="Enter Contact Person Name"
                  />
                  <div className="form-error">
                    {touched.contactPersonName &&
                      errors.contactPersonName &&
                      errors.contactPersonName}
                  </div>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    Contact Person Mobile
                  </Typography>
                  <Field
                    name="contactPersonMobile"
                    className="InputField"
                    placeholder="Enter Contact Person Mobile"
                  />
                  <div className="form-error">
                    {touched.contactPersonMobile &&
                      errors.contactPersonMobile &&
                      errors.contactPersonMobile}
                  </div>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    Description
                  </Typography>
                  <Field
                    name="description"
                    className="InputField"
                    placeholder="Enter Description"
                  />
                </Grid>
                <Grid size={{ xs: 12 }} mt={2}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "20px",
                    }}
                  >
                    <Button
                      className="cancelButton"
                      onClick={() => setOpenDrawer(false)}
                    >
                      Cancel
                    </Button>
                    <Button type="submit" className="addButton">
                      {formType === "edit" ? "Update" : "Save"}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </div>
        )}
      </Formik>
    </CrudModal>
  );
};

export default AddClientManagement;
